import React from "react";
import { motion } from "framer-motion";

export const Hero = () => {
    return (
        <section
            data-testid="hero-section"
            className="relative w-full min-h-screen overflow-hidden bg-tip-paper text-tip-black"
        >
            {/* faint grain on paper bg */}
            <div className="absolute inset-0 grain opacity-50 pointer-events-none" />

            {/* Headline content */}
            <div className="relative z-10 tip-container pt-32 md:pt-40 pb-32 md:pb-48">
                {/* Eyebrow rule */}
                <div className="flex items-center gap-4 mb-10">
                    <span className="h-[2px] w-12 bg-tip-black" />
                    <span className="eyebrow text-tip-black">
                        Estd · A Media &amp; Production House
                    </span>
                </div>

                <motion.h1
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="font-serif-display font-normal text-[44px] leading-[0.98] sm:text-6xl md:text-7xl lg:text-[100px] xl:text-[116px] tracking-[-0.025em] max-w-[16ch]"
                >
                    The World&apos;s{" "}
                    <em className="italic font-serif-display">Largest</em>{" "}
                    Democracy Deserves{" "}
                    <span className="relative inline-block">
                        <em className="italic font-serif-display">Better</em>
                        <span className="absolute -bottom-2 left-0 right-0 h-1 bg-tip-saffron" />
                    </span>{" "}
                    Entertainment
                    <span className="text-tip-saffron">.</span>
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, delay: 0.25 }}
                    className="mt-10 max-w-xl text-base md:text-lg text-tip-black/75 leading-relaxed font-body"
                >
                    The India Projekt is a next-generation media and production
                    company dedicated to exploring the ideas, stories, and
                    conversations shaping modern India.
                </motion.p>
            </div>
        </section>
    );
};
